import { trackRemoveFromFavorites } from './tracking';
import { setFavorite } from '../../../shared/actions/newbuilding';
import {
  fetchDeleteOfferFromFavorites,
  TDeleteOfferFromFavoritesRequest,
} from '../../../shared/repositories/favorites/v1/delete-offer-from-favorites';
import { IFavoriteActionTypes } from '../../../shared/types/analytics/favorite';
import { TThunkAction } from '../../../shared/types/redux/thunk';

export function removeFavorite(
  gaLabel: string,
  parameters: TDeleteOfferFromFavoritesRequest,
  eventActions?: IFavoriteActionTypes,
): TThunkAction {
  return async (dispatch, getState, { httpApi, logger }) => {
    dispatch(setFavorite(false));
    const newbuildingId = parameters.entityId;

    trackRemoveFromFavorites(gaLabel, newbuildingId, eventActions && eventActions.remove);

    try {
      await fetchDeleteOfferFromFavorites({ httpApi, parameters });
    } catch (error) {
      logger.error(error, {
        newbuildingId,
        domain: 'removeFavorite',
      });

      dispatch(setFavorite(true));
    }
  };
}
